<template>

	<div>
		<el-table
			:data="partsData"
			stripe
			style="width: 100%"
			header-cell-style = "background-color: #f2f5f9; height: 48px; text-align: center;"
		>
		
			<el-table-column label="配件名称" width="450">
				<template #default="scope">
					<div class="text-center">{{scope.row.name}}</div>
		
				</template>
			</el-table-column>
			
			<el-table-column label="规格" width="100">
				<template #default="scope">
					<div class="text-center">{{scope.row.specification}}</div>
				</template>
			</el-table-column>
			<el-table-column label="配件分类" width="100">
				<template #default="scope">
					<div class="text-center">{{scope.row.mountings_type_pname}}</div>
				</template>
			</el-table-column>
			<el-table-column label="品牌" width="100">
				<template #default="scope">
					<div class="text-center">{{scope.row.mountings_brand_name}}</div>
				</template>
			</el-table-column>
			<el-table-column label="单位" width="100">
				<template #default="scope">
					<div class="text-center">{{scope.row.unit}}</div>
				</template>
			</el-table-column>
			<el-table-column label="采购单价" width="125">
				<template #default="scope">
					<div class="text-center">{{scope.row.cost_price}}</div>
				</template>
			</el-table-column>

			<el-table-column label="采购数量" width="125">
				<template #default="scope">
					<div class="text-center">{{scope.row.member}}</div>
				</template>
			</el-table-column>
			<el-table-column label="已退" width="125">
				<template #default="scope">
					<div class="text-center">{{scope.row.return_number_}}</div>
				</template>
			</el-table-column>
			<el-table-column label="可退" width="125">
				<template #default="scope">
					<div class="text-center">{{scope.row.stock_number}}</div>
				</template>
			</el-table-column>
			<el-table-column label="退货数量" width="125">
				<template #default="scope">
					<el-input v-model="scope.row.return_number" type="text" class="mar-l-16" style="width: 80px;"></el-input>
				</template>
			</el-table-column>
		</el-table>
		
	
	
	</div>
</template>

<script>
	import {
		defineComponent
	} from "vue";
	export default defineComponent({
		name: 'editlist',
		props: {
			partsData:{
				type: Array,
				required: true,
			},
		},
		data() {
			return {
				
			};
		},
		mounted() {

		},
		methods: {
			_defItem(index){
				// if(!confirm('是否确认操作？')) return
				this.partsData.splice(index, 1)
			},
			_btn_add(){
				this.$emit('btn_add', '这是我暴露出去的数据', '这是我暴露出去的数据2')
				
				// this.tableData.push({
				// 	id: this.tableData.length + 1,
				// 	name: '123',
				// 	specification: '123',
				// 	mountings_type_pname: '123',
				// 	mountings_brand_name: '123',
				// 	unit_price: '123',
				// 	purchaseunit: '123',
				// 	quantity: '123'
				// })
			}
		},
	});
</script>

<style scoped lang="scss">
.wh-24{
	width: 24px;
	height: 24px;
}
.wh-16{
	width: 16px;
	height: 16px;
}
.btn-add{
	height: 48px;
	border: 1px dashed #f03037;
	border-radius: 4px;
	width: 100%;
	font-weight: 500;
	color: #f03037;
}
</style>
